import React from "react";

export default function About() {
  return (
    <>
      <div className="mt-5"></div>
      <section id="about" className=" bg-[#f3f4fe] py-2">
        <div className="container m-auto">
          <div className="" data-wow-delay=".2s">
            <div className="flex flex-wrap ">
              <div className="w-full px-4">
                <div
                  className="
            lg:flex
            items-center
            justify-between
            
            overflow-hidden
          "
                >
                  <div
                    className="
              lg:max-w-[565px]
              xl:max-w-[640px]
              w-full
              py-12
              px-7
              sm:px-12
              md:p-16
              lg:py-9 lg:px-10
              xl:p-[70px]
            "
                  >
                    <span
                      className="
                text-sm
                font-medium
                text-white
                py-2
                px-5
                bg-primary
                inline-block
                mb-5
              "
                    >
                      About Us
                    </span>
                    {/* <h2
                      className="
                font-bold
                text-3xl
                sm:text-4xl
                2xl:text-[40px]
                sm:leading-snug
                text-dark
                mb-6
              "
                    >
                      Brilliant Toolkit to Build Nextgen Website Faster.
                    </h2> */}
                    <p className="text-base text-body-color mb-4 leading-relaxed">
                      LMIA.LTD is owned and operated by Watershed Immigration
                      Corp, a trusted name in the field of immigration services.
                      At Watershed Immigration, we recognized the challenges
                      individuals face when seeking information about Labour
                      Market Impact Assessments (LMIA) issued by Employment and
                      Social Development Canada (ESDC). Despite the government's
                      provision of this data, accessing it can be cumbersome and
                      time-consuming.
                    </p>
                    <p className="text-base text-body-color mb-4 leading-relaxed">
                      Over time, we observed a growing need among our clients
                      for reliable verification of LMIA documents. In navigating
                      the complex landscape of LMIA-backed employment
                      opportunities in Canada, individuals encounter a myriad of
                      misinformation and fraudulent practices. This creates
                      uncertainty and poses significant challenges for both
                      employers and prospective employees alike.
                    </p>
                    <p className="text-base text-body-color mb-4 leading-relaxed">
                      Driven by a commitment to transparency and accessibility,
                      LMIA.LTD was born. Our mission is simple: to provide easy
                      access to LMIA’s issued by ESDC to anyone seeking
                      employment opportunities backed by LMIA in Canada. By
                      consolidating this information into a user-friendly
                      database, we aim to empower individuals with the knowledge
                      they need to make informed decisions about their careers
                      and immigration journeys.
                    </p>
                    <p className="text-base text-body-color mb-4 leading-relaxed">
                      At LMIA.LTD, we leverage our expertise in immigration
                      services to offer a platform that fosters trust,
                      integrity, and reliability. Join us in our mission to
                      demystify the LMIA process and unlock the potential of
                      international talent in Canada.
                    </p>
                  
                  </div>
                  <div className="text-center">
                    <div className="relative inline-block z-10">
                      <img
                        src="assets/images/about/about-image.svg"
                        className="mx-auto lg:ml-auto"
                        alt="about "
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
